import React, { Component } from 'react'
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import usericon from "../assets/images/user.png";
import whatsappicon from "../assets/images/whatsapp.svg";
import callicon from "../assets/images/call.svg";
import OpenModal from './openmodal';


const is_store = (process.env.REACT_APP_NAME === 'store');

class HeaderLinks extends Component {
    render() {
        let {token} = this.props.user.data;
        return (
            <ul className="pagelist hidepagelist list-unstyled">
                <li>
                    <Link to={is_store ? "/" : "/book-now" }>Book now</Link>
                </li>
                {
                    !token && false &&
                    <li>
                        <Link to="/register-store">Register Your Store </Link>
                    </li>
                }
                {
                    token &&
                    <>
                        <li>
                            <Link to="/orders">Orders</Link>
                        </li>
                        {
                            !is_store &&
                            <li>
                                <Link to="/offers">Offers</Link>
                            </li>
                        }
                    </>
                }
                {
                    !token && !is_store &&
                    <li>
                        <Link to="/login">Login</Link>
                    </li>
                }
                {
                    !token && !is_store &&
                    <li>
                        <Link to="/become-a-partner">Become Partner</Link>
                    </li>
                }
                <li>
                    <OpenModal btnType="btn-link" modalName="CALL_US" modalProps={{call: true}}>
                        <img src={callicon} height="30" alt="" />
                    </OpenModal>
                </li>
                <li>
                    <OpenModal btnType="btn-link" modalName="CALL_US" modalProps={{call: false}}>
                        <img src={whatsappicon} height="35" alt="" />
                    </OpenModal>
                </li>
                {token && <li className="profile-pic-li">
                    <Link to="/profile">
                        <img src={this.props.user.data.profile_pic ? this.props.user.data.profile_pic : usericon} alt={this.props.user.first_name} />
                    </Link>
                </li>}
            </ul>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.loginReducer
    }
}

const Nav = connect(mapStateToProps)(HeaderLinks);

export default Nav